import { Skeleton } from "@/components/ui/skeleton";

export const ContentCardSkeleton = () => (
  <div className="rounded-2xl border bg-card shadow-sm">
    <Skeleton className="aspect-video w-full rounded-t-2xl" />
    <div className="p-3 space-y-2">
      <Skeleton className="h-4 w-4" />
      <Skeleton className="h-3 w-1/2" />
    </div>
  </div>
);
